export { default as Img200 } from './processed/200/inhertime.jpg';
export { default as Img400 } from './processed/400/inhertime.jpg';
export { default as Img600 } from './processed/600/inhertime.jpg';
export { default as Imgthumb } from './processed/thumb/inhertime.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/inhertime.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/inhertime.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      178,
      86,
      37
    ],
    "_population": 1886,
    "_hsl": [
      0.05791962174940899,
      0.655813953488372,
      0.4215686274509804
    ]
  },
  "LightVibrant": {
    "_rgb": [
      120,
      218,
      250
    ],
    "_population": 7,
    "_hsl": [
      0.541025641025641,
      0.9285714285714286,
      0.7254901960784313
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      184,
      10,
      28
    ],
    "_population": 30,
    "_hsl": [
      0.9827586206896551,
      0.8969072164948454,
      0.3803921568627451
    ]
  },
  "Muted": {
    "_rgb": [
      176,
      114,
      84
    ],
    "_population": 588,
    "_hsl": [
      0.054347826086956534,
      0.368,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      169,
      182
    ],
    "_population": 274,
    "_hsl": [
      0.9496124031007751,
      0.33333333333333354,
      0.7470588235294118
    ]
  },
  "DarkMuted": {
    "_rgb": [
      96,
      79,
      44
    ],
    "_population": 120,
    "_hsl": [
      0.11217948717948718,
      0.3714285714285714,
      0.27450980392156865
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/inhertime.js